import { render, staticRenderFns } from "./FlowmapImage.vue?vue&type=template&id=4679afdf&scoped=true&"
import script from "./FlowmapImage.vue?vue&type=script&lang=js&"
export * from "./FlowmapImage.vue?vue&type=script&lang=js&"
import style0 from "./FlowmapImage.vue?vue&type=style&index=0&id=4679afdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679afdf",
  null
  
)

export default component.exports